import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination-buttons"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "pagination-info" }
const _hoisted_5 = { class: "estate-listing-filter__item-label" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "pagination" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.simple)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "buttons"),
        _createElementVNode("button", {
          disabled: _ctx.isPreviousButtonDisabled,
          class: "prev button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args)))
        }, null, 8, _hoisted_2),
        _createElementVNode("button", {
          disabled: _ctx.isNextButtonDisabled,
          class: "next button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
        }, null, 8, _hoisted_3)
      ]))
    : (_ctx.pageCount > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('pager.displays')) + ": ", 1),
            (_ctx.currentCount === _ctx.totalCount)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString(_ctx.currentCount), 1))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  innerHTML: _ctx.$t('pager.line', { currentCount: _ctx.currentCount, totalCount: _ctx.totalCount, page: _ctx.currentPage })
                }, null, 8, _hoisted_7))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              disabled: _ctx.isPreviousButtonDisabled,
              class: "prev button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args)))
            }, null, 8, _hoisted_9),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationTriggers, (paginationTrigger, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["pagination-trigger pagination__description", {
          'pagination__description--current': paginationTrigger === _ctx.currentPage,
          'pagination__description--disabled': paginationTrigger === _ctx.dots,
        }]),
                onClick: ($event: any) => (_ctx.onLoadPage(paginationTrigger)),
                key: index
              }, _toDisplayString(paginationTrigger), 11, _hoisted_10))
            }), 128)),
            _createElementVNode("button", {
              disabled: _ctx.isNextButtonDisabled,
              class: "next button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
            }, null, 8, _hoisted_11)
          ])
        ], 64))
      : _createCommentVNode("", true)
}